"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WizardControlStep = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ui = require("../../../ui");
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var H4 = (0, _styledComponents.default)(_ui.H4)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-bottom: 0;\n"])));
var WizardControlStep = _styledComponents.default.div.attrs(function (_ref) {
  var step = _ref.step;
  return {
    children: /*#__PURE__*/_react.default.createElement(H4, null, step + 1)
  };
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  height: 52px;\n  width: 52px;\n  border-radius: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: ", ";\n  cursor: default;\n  margin: 0;\n  font-weight: normal;\n  color: ", ";\n"])), function (_ref2) {
  var theme = _ref2.theme,
    step = _ref2.step,
    currentStep = _ref2.currentStep;
  return step <= currentStep ? theme.colors.primary : theme.colors.tertiaryShade;
}, function (_ref3) {
  var theme = _ref3.theme,
    step = _ref3.step,
    currentStep = _ref3.currentStep;
  return step <= currentStep ? theme.colors.secondary : theme.colors.secondary;
});
exports.WizardControlStep = WizardControlStep;